import ValueEditorNumberProperty from "./ValueEditorNumberProperty";

export default ValueEditorNumberProperty;
export { ValueEditorNumberProperty };
